import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tag2 } from '@platform/ui'
import { CourseFiltersDrawer } from '@/components/CourseFiltersDrawer/CourseFiltersDrawer'
import { FilterDrawerType } from '@/components/CourseFiltersDrawer/types'
import { useCourseFilter } from '@/hooks/useCourseFilter'
import { useAppSelector } from '@/store/hooks'
import styles from './CourseFilterButton.module.scss'

type Props = {
  type: FilterDrawerType
}

export const CourseFilterButton = ({ type }: Props) => {
  const { t } = useTranslation()

  const [isOpen, setIsOpen] = useState(false)

  const termIds = useAppSelector((state) => state.aggregates.termIds)
  const { collectionFilters, filterCount } = useCourseFilter({ type })

  if (
    (type === 'catalog' && !termIds.length && !collectionFilters.length) ||
    (type === 'public' && !collectionFilters.length)
  ) {
    return null
  }

  return (
    <>
      <CourseFiltersDrawer type={type} isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <div className={styles.wrapper}>
        <Tag2
          iconBeforeProps={{ name: 'FilterBoldStroke', title: t('coursesFilterDrawer.openFilterDrawer') }}
          isActive={isOpen}
          onClick={() => setIsOpen((open) => !open)}
          text={t('coursesFilterDrawer.openFilterDrawer')}
        />
        {filterCount > 0 && <div className={styles.dot}>{filterCount}</div>}
      </div>
    </>
  )
}
